import { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import membersData from '../data/members.json';

interface Member {
  id: number;
  name: string;
  role: string;
  bio: string;
  image: string;
  facePosition: string;
}

const Members = () => {
  const [members, setMembers] = useState<Member[]>([]);

  useEffect(() => {
    // Sort members by ID and force a re-render by creating a new array
    const sortedMembers = [...membersData.members].sort((a, b) => a.id - b.id);
    setMembers(sortedMembers);
  }, [membersData]); // Add membersData as a dependency

  const getImageStyle = (facePosition: string) => {
    const style: React.CSSProperties = {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    };

    switch (facePosition) {
      case 'N':
        style.objectPosition = 'center top';
        break;
      case 'S':
        style.objectPosition = 'center bottom';
        break;
      case 'E':
        style.objectPosition = 'right center';
        break;
      case 'W':
        style.objectPosition = 'left center';
        break;
      case 'NE':
        style.objectPosition = 'right top';
        break;
      case 'NW':
        style.objectPosition = 'left top';
        break;
      case 'SE':
        style.objectPosition = 'right bottom';
        break;
      case 'SW':
        style.objectPosition = 'left bottom';
        break;
      default:
        style.objectPosition = 'center center';
    }

    return style;
  };

  return (
    <Container>
      <h1 className="mb-4 text-white">Our Conductor</h1>
      <div className="conductor-container">
        <div className="conductor-box">
          <div className="d-flex h-100">
            <div className="conductor-image-container">
              <img src="./images/members/jayne.jpg" alt="Jayne" className="conductor-image" />
            </div>
            <div className="conductor-content">
              <div className="conductor-info">
                <div className=" align-items-center">
                  <span className="text-white me-2">Name:</span>
                  <span className="text-accent me-4">Jayne Murril</span>
                </div>
              </div>
              <div className="conductor-bio">
                <p className="text-white small">Jayne has been conducting the band since 2015</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h1 className="mb-4 text-white">Our Members</h1>
      <div className="members-container">
        {members.map((member) => (
          <div key={member.id} className="member-box">
            <div className="d-flex h-100">
              <div className="member-image-container">
                <img src={member.image} alt={member.name} className="member-image" style={getImageStyle(member.facePosition)} />
              </div>
              <div className="member-content">
                <div className="member-info">
                  <div className="align-items-left">
                    <span className="text-white me-2">Name:</span>
                    <span className="text-accent">{member.name}</span>
                  </div>
                  <div className=" align-items-left">
                    <span className="text-white me-2">Position:</span>
                    <span className="text-accent">{member.role}</span>
                  </div>
                </div>
                <div className="member-bio">
                  <p className="text-white small">{member.bio}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default Members; 